import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: 2000
    },
    attrs: {
      persistent: "",
      "max-width": "80%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close();
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Order accountancy reconciliation")])]), _c(VCardText, [_c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTab, {
    key: 1
  }, [_vm._v("Associations")]), !_vm.isOrderOldStockTransfer ? _c(VTab, {
    key: 2
  }, [_vm._v("Sum up invoices")]) : _vm._e()], 1), !_vm.firstLoaded ? _c("div", {
    staticClass: "text-center mt-default"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : _c(VTabsItems, {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabItem, {
    key: 1
  }, _vm._l(_vm.ocOrder.items, function (orderItem) {
    var _vm$associationsByOcI, _vm$associationsByOcI2, _vm$associationsByOcI3, _vm$associationsByOcI4, _vm$associationsByOcI5, _vm$associationsByOcI10, _vm$associationsByOcI11, _vm$associationsByOcI12, _vm$associationsByOcI13, _vm$associationsByOcI14, _vm$associationsByOcI15, _vm$associationsByOcI16, _vm$associationsByOcI17;
    return _c("div", {
      key: "orderItem-" + orderItem.id_item,
      staticClass: "association-item-container"
    }, [_c("div", [orderItem.quantity === ((_vm$associationsByOcI = (_vm$associationsByOcI2 = _vm.associationsByOcItemId.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    })) === null || _vm$associationsByOcI2 === void 0 || (_vm$associationsByOcI2 = _vm$associationsByOcI2.associations) === null || _vm$associationsByOcI2 === void 0 ? void 0 : _vm$associationsByOcI2.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByOcI !== void 0 ? _vm$associationsByOcI : 0) ? _c(VIcon, {
      staticClass: "fa fa-check success text-xs"
    }) : ((_vm$associationsByOcI3 = (_vm$associationsByOcI4 = _vm.associationsByOcItemId.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    })) === null || _vm$associationsByOcI4 === void 0 || (_vm$associationsByOcI4 = _vm$associationsByOcI4.associations) === null || _vm$associationsByOcI4 === void 0 ? void 0 : _vm$associationsByOcI4.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByOcI3 !== void 0 ? _vm$associationsByOcI3 : 0) > 0 ? _c(VIcon, {
      staticClass: "fa fa-percent warning text-xs"
    }) : _c(VIcon, {
      staticClass: "fa fa-percent danger text-xs"
    }), _c("span", {
      staticClass: "text-bold ml-1"
    }, [_vm._v(" " + _vm._s("".concat(orderItem.quantity, " b. ").concat(orderItem.wine.accountancy_code, " :")) + " ")]), _c("span", {
      staticClass: "text-smaller ml-1"
    }, [_vm._v(" " + _vm._s(_vm.wineNaming(_vm.$whitelabel, orderItem.wine.naming_data, true, true)) + " ")])], 1), ((_vm$associationsByOcI5 = _vm.associationsByOcItemId.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    })) === null || _vm$associationsByOcI5 === void 0 || (_vm$associationsByOcI5 = _vm$associationsByOcI5.associations) === null || _vm$associationsByOcI5 === void 0 ? void 0 : _vm$associationsByOcI5.length) > 0 ? _c("div", _vm._l(_vm.associationsByOcItemId.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    }).associations, function (association) {
      var _association$payment, _association$payment$, _association$oldPayme, _association$payment2, _association$oldPayme2, _vm$associationsByOcI6, _vm$associationsByOcI7, _vm$associationsByOcI8, _vm$associationsByOcI9;
      return _c("div", {
        key: "association-" + association.id
      }, [_c("div", {
        staticClass: "flex gap-2"
      }, [!association.isExternalEcAssociation ? _c("div", [_c(VIcon, {
        staticClass: "fa fa-link text-sm mr-2"
      }), _c("span", {
        staticClass: "text-bold"
      }, [_vm._v(" " + _vm._s("".concat(association.nbBottlesAssociated, " b. on ")) + " "), _c("router-link", {
        staticClass: "router-link",
        attrs: {
          to: _vm.orderDetails(association.ecItemData.orderId),
          target: "_blank"
        }
      }, [_vm._v(" " + _vm._s("".concat(association.ecItemData.orderInvoiceNumberLabel, ", ")) + " ")]), _vm._v(" " + _vm._s("".concat(_vm.formatPrice(association.ocItemData.itemTotalAmountCurrencyIncludeShipping), " ").concat(_vm.getSymbolCurrency(association.ocItemData.currency))) + " " + _vm._s(((_association$payment = association.payment) === null || _association$payment === void 0 ? void 0 : _association$payment.id) > 0 ? " (".concat(((_association$payment$ = association.payment.reference) === null || _association$payment$ === void 0 ? void 0 : _association$payment$.length) > 0 ? association.payment.reference : "#NoRef", ")") : (_association$oldPayme = association.oldPaymentReferences) !== null && _association$oldPayme !== void 0 && _association$oldPayme.length ? " (".concat(association.oldPaymentReferences.join(" , "), " - previous version)") : "") + " ")], 1), association.isAutomatic ? _c("span", [_vm._v("(auto)")]) : _vm._e(), _c("span", [_vm._v(":")]), _c("span", {
        staticClass: "text-smaller"
      }, [_vm._v(" " + _vm._s("".concat(association.ecItemData.orderReferenceLabel.shorterReference(), ", ").concat(association.ecItemData.orderCustomerDisplayName)) + " ")])], 1) : _c("div", [_c(VIcon, {
        staticClass: "fa fa-link text-sm mr-2"
      }), _c("span", {
        staticClass: "text-bold"
      }, [_vm._v(" " + _vm._s("".concat(association.nbBottlesAssociated, " b. on ").concat(association.externalEcItemData.invoiceReference, ", ")) + " " + _vm._s("".concat(_vm.formatPrice(association.ocItemData.itemTotalAmountCurrencyIncludeShipping), " ").concat(_vm.getSymbolCurrency(association.ocItemData.currency))) + " " + _vm._s(((_association$payment2 = association.payment) === null || _association$payment2 === void 0 ? void 0 : _association$payment2.id) > 0 ? " (".concat(association.payment.reference, ")") : (_association$oldPayme2 = association.oldPaymentReferences) !== null && _association$oldPayme2 !== void 0 && _association$oldPayme2.length ? " (".concat(association.oldPaymentReferences.join(" , "), " - previous version)") : "") + " ")])], 1), !_vm.updatingForms.some(function (x) {
        return x.associationId === association.id;
      }) && !_vm.updatingExternalForms.some(function (x) {
        return x.associationId === association.id;
      }) ? _c("div", {
        staticClass: "flex gap-2"
      }, [_c(VIcon, {
        staticClass: "fa fa-pen text-sm",
        attrs: {
          disabled: _vm.addingForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.addingExternalForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.updatingForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.updatingExternalForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.isDeleting.some(function (x) {
            return x.associationId === association.id;
          }),
          title: "Edit"
        },
        on: {
          click: function click($event) {
            !association.isExternalEcAssociation ? _vm.openUpdatingForm(association.id, orderItem.id_item) : _vm.openUpdatingExternalForm(association.id, orderItem.id_item);
          }
        }
      }), _c(VIcon, {
        staticClass: "fa fa-trash text-sm",
        attrs: {
          disabled: _vm.addingForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.addingExternalForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.updatingForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.updatingExternalForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.isDeleting.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }),
          title: "Delete"
        },
        on: {
          click: function click($event) {
            return _vm.confirmDeleteAssociation(association.id, orderItem.id_item);
          }
        }
      })], 1) : _vm._e()]), _vm.updatingForms.some(function (x) {
        return x.associationId === association.id;
      }) ? [_c("div", {
        staticClass: "subform-bordered"
      }, [_c(VForm, {
        model: {
          value: _vm.updatingForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingForms.find(function (x) {
              return x.associationId === association.id;
            }), "isValid", $$v);
          },
          expression: "\n                        updatingForms.find(x => x.associationId === association.id).isValid\n                      "
        }
      }, [_c("div", {
        staticClass: "flex gap-2"
      }, [_c("div", {
        staticStyle: {
          width: "4rem"
        }
      }, [_c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          autofocus: "",
          type: "number",
          min: 1,
          max: orderItem.quantity - ((_vm$associationsByOcI6 = (_vm$associationsByOcI7 = _vm.associationsByOcItemId.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          })) === null || _vm$associationsByOcI7 === void 0 || (_vm$associationsByOcI7 = _vm$associationsByOcI7.associations) === null || _vm$associationsByOcI7 === void 0 || (_vm$associationsByOcI7 = _vm$associationsByOcI7.filter(function (x) {
            return x.id !== association.id;
          })) === null || _vm$associationsByOcI7 === void 0 ? void 0 : _vm$associationsByOcI7.reduce(function (acc, item) {
            return acc + item.nbBottlesAssociated;
          }, 0)) !== null && _vm$associationsByOcI6 !== void 0 ? _vm$associationsByOcI6 : 0),
          suffix: "b.",
          rules: [_vm.formRules.mustBeGreaterThan0],
          "hide-details": "auto"
        },
        on: {
          keypress: _vm.filterIntegerKey
        },
        model: {
          value: _vm.updatingForms.find(function (x) {
            return x.associationId === association.id;
          }).quantity,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingForms.find(function (x) {
              return x.associationId === association.id;
            }), "quantity", $$v);
          },
          expression: "\n                              updatingForms.find(x => x.associationId === association.id).quantity\n                            "
        }
      })], 1)]), _c("div", [_c(VAutocomplete, {
        staticClass: "v-text-field-no-label",
        attrs: {
          placeholder: "OC Payment",
          items: _vm.ocPaymentsForSelector,
          "item-value": "id",
          "item-text": "selectorDisplayName",
          clearable: "",
          "hide-details": "auto",
          filter: _vm.filterVAutocomplete
        },
        model: {
          value: _vm.updatingForms.find(function (x) {
            return x.associationId === association.id;
          }).paymentId,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingForms.find(function (x) {
              return x.associationId === association.id;
            }), "paymentId", $$v);
          },
          expression: "\n                            updatingForms.find(x => x.associationId === association.id).paymentId\n                          "
        }
      })], 1), _c("div", {
        staticClass: "mt-3 flex"
      }, [_c(VBtn, {
        staticClass: "dfwa-btn --small-2 secondary",
        attrs: {
          rounded: "",
          disabled: _vm.isUpdating.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.closeUpdatingForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-times mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Cancel ")], 1), _c(VBtn, {
        staticClass: "dfwa-btn --small-2 highlight",
        attrs: {
          rounded: "",
          disabled: !_vm.updatingForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          loading: _vm.isUpdating.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.saveUpdatingForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-save mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Save association ")], 1)], 1)])], 1)] : _vm._e(), _vm.updatingExternalForms.some(function (x) {
        return x.associationId === association.id;
      }) ? [_c("div", {
        staticClass: "subform-bordered"
      }, [_c(VForm, {
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.associationId === association.id;
            }), "isValid", $$v);
          },
          expression: "\n                        updatingExternalForms.find(x => x.associationId === association.id)\n                          .isValid\n                      "
        }
      }, [_c("div", {
        staticClass: "flex gap-2"
      }, [_c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          rules: [_vm.formRules.mustNotBeEmpty],
          placeholder: "External EC reference",
          "hide-details": "auto"
        },
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }).externalEcReference,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.ocItemId === orderItem.id_item;
            }), "externalEcReference", $$v);
          },
          expression: "\n                            updatingExternalForms.find(x => x.ocItemId === orderItem.id_item)\n                              .externalEcReference\n                          "
        }
      }), _c("div", {
        staticStyle: {
          width: "4rem"
        }
      }, [_c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          autofocus: "",
          type: "number",
          min: 1,
          max: orderItem.quantity - ((_vm$associationsByOcI8 = (_vm$associationsByOcI9 = _vm.associationsByOcItemId.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          })) === null || _vm$associationsByOcI9 === void 0 || (_vm$associationsByOcI9 = _vm$associationsByOcI9.associations) === null || _vm$associationsByOcI9 === void 0 || (_vm$associationsByOcI9 = _vm$associationsByOcI9.filter(function (x) {
            return x.id !== association.id;
          })) === null || _vm$associationsByOcI9 === void 0 ? void 0 : _vm$associationsByOcI9.reduce(function (acc, item) {
            return acc + item.nbBottlesAssociated;
          }, 0)) !== null && _vm$associationsByOcI8 !== void 0 ? _vm$associationsByOcI8 : 0),
          suffix: "b.",
          rules: [_vm.formRules.mustBeGreaterThan0],
          "hide-details": "auto"
        },
        on: {
          keypress: _vm.filterIntegerKey
        },
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).quantity,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.associationId === association.id;
            }), "quantity", $$v);
          },
          expression: "\n                              updatingExternalForms.find(x => x.associationId === association.id)\n                                .quantity\n                            "
        }
      })], 1)], 1), _c("div", [_c(VAutocomplete, {
        staticClass: "v-text-field-no-label",
        attrs: {
          placeholder: "OC Payment",
          items: _vm.ocPaymentsForSelector,
          "item-value": "id",
          "item-text": "selectorDisplayName",
          clearable: "",
          "hide-details": "auto",
          filter: _vm.filterVAutocomplete
        },
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).paymentId,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.associationId === association.id;
            }), "paymentId", $$v);
          },
          expression: "\n                            updatingExternalForms.find(x => x.associationId === association.id)\n                              .paymentId\n                          "
        }
      })], 1), _c("div", {
        staticClass: "mt-3 flex"
      }, [_c(VBtn, {
        staticClass: "dfwa-btn --small-2 secondary",
        attrs: {
          rounded: "",
          disabled: _vm.isUpdatingExternal.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.closeUpdatingExternalForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-times mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Cancel ")], 1), _c(VBtn, {
        staticClass: "dfwa-btn --small-2 highlight",
        attrs: {
          rounded: "",
          disabled: !_vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          loading: _vm.isUpdatingExternal.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.saveUpdatingExternalForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-save mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Save association ")], 1)], 1)])], 1)] : _vm._e()], 2);
    }), 0) : _vm._e(), _vm.addingForms.some(function (x) {
      return x.ocItemId === orderItem.id_item;
    }) ? _c("div", [_vm.addingForms.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    }).isLoadingAvailableReconciliations ? _c("div", [_vm._v(" Serching for compatible orders ... ")]) : _vm.addingForms.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    }).availableReconciliations.length === 0 ? _c("div", [_vm._v(" No order seems to be compatible with this item ")]) : _c("div", {
      staticClass: "subform-bordered"
    }, [_c(VForm, {
      model: {
        value: _vm.addingForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).isValid,
        callback: function callback($$v) {
          _vm.$set(_vm.addingForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "isValid", $$v);
        },
        expression: "addingForms.find(x => x.ocItemId === orderItem.id_item).isValid"
      }
    }, [_c("div", {
      staticClass: "flex gap-2"
    }, [_c("div", [_c(VIcon, {
      staticClass: "fa fa-link text-sm"
    }), _c("div", {
      staticStyle: {
        position: "absolute",
        top: "-6px",
        right: "-5px"
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus success",
      attrs: {
        size: "0.4rem"
      }
    })], 1)], 1), _c(VAutocomplete, {
      staticClass: "v-text-field-no-label",
      attrs: {
        placeholder: "Order",
        items: _vm.addingForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).availableReconciliations,
        "item-value": "ecItemId",
        "item-text": "label",
        rules: [_vm.formRules.mustSelectValue],
        clearable: "",
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: _vm.addingForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).ecItemId,
        callback: function callback($$v) {
          _vm.$set(_vm.addingForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "ecItemId", $$v);
        },
        expression: "addingForms.find(x => x.ocItemId === orderItem.id_item).ecItemId"
      }
    }), !!_vm.addingForms.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    }).ecItemId ? _c("div", {
      staticStyle: {
        width: "4rem"
      }
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label",
      attrs: {
        type: "number",
        autofocus: "",
        min: 1,
        max: Math.min(_vm.addingForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).availableReconciliations.find(function (x) {
          return x.ecItemId === _vm.addingForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }).ecItemId;
        }).nbBottlesAvailable, orderItem.quantity - ((_vm$associationsByOcI10 = (_vm$associationsByOcI11 = _vm.associationsByOcItemId.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        })) === null || _vm$associationsByOcI11 === void 0 || (_vm$associationsByOcI11 = _vm$associationsByOcI11.associations) === null || _vm$associationsByOcI11 === void 0 ? void 0 : _vm$associationsByOcI11.reduce(function (acc, item) {
          return acc + item.nbBottlesAssociated;
        }, 0)) !== null && _vm$associationsByOcI10 !== void 0 ? _vm$associationsByOcI10 : 0)),
        suffix: "b.",
        rules: [_vm.formRules.mustBeGreaterThan0],
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: _vm.addingForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).nbBottlesAssociated,
        callback: function callback($$v) {
          _vm.$set(_vm.addingForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "nbBottlesAssociated", $$v);
        },
        expression: "\n                          addingForms.find(x => x.ocItemId === orderItem.id_item)\n                            .nbBottlesAssociated\n                        "
      }
    })], 1) : _vm._e()], 1), _c("div", [_c(VAutocomplete, {
      staticClass: "v-text-field-no-label",
      attrs: {
        placeholder: "OC Payment",
        items: _vm.ocPaymentsForSelector,
        "item-value": "id",
        "item-text": "selectorDisplayName",
        clearable: "",
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: _vm.addingForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).paymentId,
        callback: function callback($$v) {
          _vm.$set(_vm.addingForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "paymentId", $$v);
        },
        expression: "addingForms.find(x => x.ocItemId === orderItem.id_item).paymentId"
      }
    })], 1), _c("div", {
      staticClass: "mt-3 flex"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        disabled: _vm.isAdding.includes(orderItem.id_item),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.closeAddingForm(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        disabled: !_vm.addingForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).isValid,
        loading: _vm.isAdding.includes(orderItem.id_item),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.saveAddingForm(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-save mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Create association ")], 1)], 1)])], 1)]) : _vm.addingExternalForms.some(function (x) {
      return x.ocItemId === orderItem.id_item;
    }) ? _c("div", [_c("div", {
      staticClass: "subform-bordered"
    }, [_c(VForm, {
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).isValid,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "isValid", $$v);
        },
        expression: "\n                    addingExternalForms.find(x => x.ocItemId === orderItem.id_item).isValid\n                  "
      }
    }, [_c("div", {
      staticClass: "flex gap-2"
    }, [_c("div", [_c(VIcon, {
      staticClass: "fa fa-link text-sm"
    }), _c("div", {
      staticStyle: {
        position: "absolute",
        top: "-6px",
        right: "-5px"
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus success",
      attrs: {
        size: "0.4rem"
      }
    })], 1)], 1), _c(VTextField, {
      staticClass: "v-text-field-no-label",
      attrs: {
        rules: [_vm.formRules.mustNotBeEmpty],
        placeholder: "External EC reference",
        "hide-details": "auto"
      },
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).externalEcReference,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "externalEcReference", $$v);
        },
        expression: "\n                        addingExternalForms.find(x => x.ocItemId === orderItem.id_item)\n                          .externalEcReference\n                      "
      }
    }), _c("div", {
      staticStyle: {
        width: "4rem"
      }
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label",
      attrs: {
        type: "number",
        autofocus: "",
        min: 1,
        max: orderItem.quantity - ((_vm$associationsByOcI12 = (_vm$associationsByOcI13 = _vm.associationsByOcItemId.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        })) === null || _vm$associationsByOcI13 === void 0 || (_vm$associationsByOcI13 = _vm$associationsByOcI13.associations) === null || _vm$associationsByOcI13 === void 0 ? void 0 : _vm$associationsByOcI13.reduce(function (acc, item) {
          return acc + item.nbBottlesAssociated;
        }, 0)) !== null && _vm$associationsByOcI12 !== void 0 ? _vm$associationsByOcI12 : 0),
        suffix: "b.",
        rules: [_vm.formRules.mustBeGreaterThan0],
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).nbBottlesAssociated,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "nbBottlesAssociated", $$v);
        },
        expression: "\n                          addingExternalForms.find(x => x.ocItemId === orderItem.id_item)\n                            .nbBottlesAssociated\n                        "
      }
    })], 1)], 1), _c("div", [_c(VAutocomplete, {
      staticClass: "v-text-field-no-label",
      attrs: {
        placeholder: "OC Payment",
        items: _vm.ocPaymentsForSelector,
        "item-value": "id",
        "item-text": "selectorDisplayName",
        clearable: "",
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).paymentId,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ocItemId === orderItem.id_item;
          }), "paymentId", $$v);
        },
        expression: "\n                        addingExternalForms.find(x => x.ocItemId === orderItem.id_item).paymentId\n                      "
      }
    })], 1), _c("div", {
      staticClass: "mt-3 flex"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        disabled: _vm.isAddingExternal.includes(orderItem.id_item),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.closeAddingExternalForm(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        disabled: !_vm.addingExternalForms.find(function (x) {
          return x.ocItemId === orderItem.id_item;
        }).isValid,
        loading: _vm.isAddingExternal.includes(orderItem.id_item),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.saveAddingExternalForm(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-save mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Create association ")], 1)], 1)])], 1)]) : orderItem.quantity > ((_vm$associationsByOcI14 = (_vm$associationsByOcI15 = _vm.associationsByOcItemId.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    })) === null || _vm$associationsByOcI15 === void 0 || (_vm$associationsByOcI15 = _vm$associationsByOcI15.associations) === null || _vm$associationsByOcI15 === void 0 ? void 0 : _vm$associationsByOcI15.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByOcI14 !== void 0 ? _vm$associationsByOcI14 : 0) ? _c("div", [_c("div", [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        disabled: _vm.updatingForms.some(function (x) {
          return x.ocItemId === orderItem.id_item;
        }) || _vm.updatingExternalForms.some(function (x) {
          return x.ocItemId === orderItem.id_item;
        }) || _vm.isDeleting.some(function (x) {
          return x.ocItemId === orderItem.id_item;
        }),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.getAvailableReconciliationsForItem(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Add association ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        disabled: _vm.updatingForms.some(function (x) {
          return x.ocItemId === orderItem.id_item;
        }) || _vm.updatingExternalForms.some(function (x) {
          return x.ocItemId === orderItem.id_item;
        }) || _vm.isDeleting.some(function (x) {
          return x.ocItemId === orderItem.id_item;
        }),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.openExternalFormForItem(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Add external association ")], 1)], 1), _c("div", [_c("span", {
      staticClass: "text-smaller text-italic"
    }, [_vm._v(" " + _vm._s(orderItem.quantity - ((_vm$associationsByOcI16 = (_vm$associationsByOcI17 = _vm.associationsByOcItemId.find(function (x) {
      return x.ocItemId === orderItem.id_item;
    })) === null || _vm$associationsByOcI17 === void 0 || (_vm$associationsByOcI17 = _vm$associationsByOcI17.associations) === null || _vm$associationsByOcI17 === void 0 ? void 0 : _vm$associationsByOcI17.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByOcI16 !== void 0 ? _vm$associationsByOcI16 : 0)) + " bottle(s) not reconcilied ")])])]) : _vm._e()]);
  }), 0), !_vm.isOrderOldStockTransfer ? _c(VTabItem, {
    key: 2
  }, [_vm.associationsByEcOrderId.length <= 0 ? _c("div", {
    staticClass: "mt-default text-h6"
  }, [_vm._v(" No association saved ")]) : _c("div", {
    staticClass: "mt-default"
  }, [_c(VDataTable, {
    attrs: {
      headers: _vm.sumUpInvoices.tableHeaders,
      items: _vm.associationsByEcOrderId,
      "items-per-page": _vm.associationsByEcOrderId.length,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.invoiceNumberLabel",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [!item.isExternalEcAssociation ? _c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.orderDetails(item.orderId)
          }
        }, [_vm._v(" " + _vm._s(item.invoiceNumberLabel) + " ")]) : _c("span", [_vm._v(" " + _vm._s(item.invoiceNumberLabel) + " ")])];
      }
    }, {
      key: "item.orderData",
      fn: function fn(_ref2) {
        var _item$orderAccountanc;
        var item = _ref2.item;
        return [!item.isExternalEcAssociation ? _c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.orderDetails(item.orderId)
          }
        }, [_vm._v(" " + _vm._s(((_item$orderAccountanc = item.orderAccountancyCode) === null || _item$orderAccountanc === void 0 ? void 0 : _item$orderAccountanc.length) > 0 ? "".concat(item.orderAccountancyCode, ", ") : "") + " " + _vm._s("".concat(item.referenceLabel.shorterReference(), ", ").concat(item.customerDisplayName)) + " ")]) : _c("span", [_vm._v("-")])];
      }
    }, {
      key: "item.totalAmountCurrencyIncludeShipping",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "text-bold"
        }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.totalAmountCurrencyIncludeShipping)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")])];
      }
    }, {
      key: "item.oldPaymentReferences",
      fn: function fn(_ref4) {
        var _item$oldPaymentRefer;
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "text-smaller"
        }, [item.payments.length > 0 ? _c("div", {
          staticClass: "flex flex-column items-start"
        }, _vm._l(item.payments, function (payment) {
          return _c("span", {
            key: "sumUpExtPayment-" + payment.id
          }, [_vm._v(" " + _vm._s("#".concat(payment.reference, " : ").concat(_vm.formatPrice(payment.sumAmount)).concat(_vm.getSymbolCurrency(item.currency))) + " ")]);
        }), 0) : _vm._e(), ((_item$oldPaymentRefer = item.oldPaymentReferences) === null || _item$oldPaymentRefer === void 0 ? void 0 : _item$oldPaymentRefer.length) > 0 ? _c("div", [_vm._v(" " + _vm._s(item.oldPaymentReferences) + " ")]) : _vm._e()])];
      }
    }], null, true)
  })], 1)]) : _vm._e()], 1)], 1), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isLoadingAssociations
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" Close ")])], 1)], 1), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };